export enum ButtonPurpose {
  Danger = 'btn-danger',
  Info = 'btn-info',
  Primary = 'btn-primary',
  Secondary = 'btn-secondary',
  Tertiary = 'btn-tertiary',
  Icon = 'btn-icon',
  Success = 'btn-success',
  Warning = 'btn-warning',
}
